/**
 * @fileoverview Module for `src/components/Loading.js`.
 */

import classNames from 'classnames';
import PropTypes from 'prop-types';

/**
 * Generic loading spinner container.
 *
 * @param {Object} params
 * @returns {JSX.Element} Loading indicator.
 */
function Loading({ className, style }) {
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FDFAF0', // vf-cream
    ...style,
  };

  return (
    <div
      className={ classNames('loading-spinner', className) }
      style={ containerStyle }
    >
      <div className='p-3 fa fa-pulse fa-spinner waiting fa-3x' title='Loading' />
    </div>
  );
}

Loading.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Loading;
